__webpack_require__.p = "/react-marusya-app/";